<script setup>
defineProps({
  appliedFilters: {
    type: Array,
    required: true,
  },
  removeFilter: {
    type: Function,
    required: true,
  },
})
</script>

<template>
  <div class="d-flex flex-row flex-wrap align-center ga-2">
    <v-chip
      v-for="(appliedFilter, index) in appliedFilters"
      :key="index"
      class="bg-pattern-background-color"
      close-icon="mdi-close"
      :append-icon="!appliedFilter.forced ? 'mdi-close' : undefined"
      @click="() => (!appliedFilter.forced ? removeFilter(index) : undefined)"
    >
      {{ appliedFilter.text }}
    </v-chip>
  </div>
</template>
